import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShield2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShield2"><Path d="M3.5 5.5L12 2L20.5 5.5V13C20.5 17.6944 16.6944 21.5 12 21.5C7.30558 21.5 3.5 17.6944 3.5 13V5.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconShield2;
